module.exports = __webpack_public_path__ + "static/media/samsung-aife-2019.d202dc1b.mp4";